import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

/**
 * End / hang-up call — classic tilted handset with X (matches provided asset).
 */
export const MeetingsEndCallIcon: React.FC<IconProps> = (props) => (
  <Icon
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.2 4.2C5.2 4 4.3 4.6 4.1 5.6C3.5 8.8 4.6 12.1 7 14.5C9.4 16.9 12.7 18 15.9 17.4C16.9 17.2 17.5 16.3 17.3 15.3L16.8 13C16.6 12.2 15.8 11.7 15 11.9L13.2 12.4C12.7 12.5 12.1 12.4 11.7 12C10.3 10.9 9.2 9.4 8.5 7.7C8.3 7.2 8.2 6.6 8.3 6.1L8.8 4.3C9 3.5 8.5 2.7 7.5 2.5L6.2 4.2Z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="rotate(18 11 10)"
    />
    <path
      d="M15.5 3.5L20 8M20 3.5L15.5 8"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </Icon>
);
